<template>
  <v-card>
    <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
    <v-card-title>
      <h4>{{ editedItem.id ? "Redigera delmoment" : "Lägg till delmoment"}}</h4>
    </v-card-title>

    <v-card-text>
      <v-form ref="form">
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="12">
            <v-text-field :rules="[rules.required]" outlined v-model="editedItem.name" label="Namn"></v-text-field>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-text-field
              outlined
              v-model="editedItem.requiredLevel"
              label="Nivå för godkännande (1-4)"
              type="number"
              min="0"
              max="4"
              :rules="[rules.integer]"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-checkbox
              class="pl-6"
              :false-value="false"
              :true-value="true"
              v-model="editedItem.required"
              label="Obligatorisk?"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="12" md="12" class>
            <v-textarea
              outlined
              rows="4"
              v-model="editedItem.description"
              label="Beskrivning färdighet"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-textarea outlined rows="3" v-model="editedItem.level1Text" label="Text nivå 1"></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-textarea outlined rows="3" v-model="editedItem.level2Text" label="Text nivå 2"></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-textarea outlined rows="3" v-model="editedItem.level3Text" label="Text nivå 3"></v-textarea>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-textarea outlined rows="3" v-model="editedItem.level4Text" label="Text nivå 4"></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn color="secondary" @click="$emit('close')">
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
      <v-btn class="icon" @click="saveSub()">
        <v-icon>$sl-check</v-icon>Spara
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {RulesMixin} from '@/components/mixins'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import filter from 'lodash/filter'
import omit from 'lodash/omit'
import maxBy from 'lodash/maxBy'

// @group Ebook
// Styled ProviderBookElementsModal component
export default {
  name: 'ProviderBookElementsModal',

  props: {
    //has edited item
    editedItem: Object
  },

  mixins: [RulesMixin],

  methods: {
    saveSub() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }
      // Fire save event
      // @arg The argument is object representing edited item
      this.$emit('save', this.editedItem)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>